import { Route } from 'react-router-dom';
import { Suspense, lazy } from 'react';

// Lazy load public pages
const Index = lazy(() => import('@/pages/Index'));
const About = lazy(() => import('@/pages/About'));
const Contact = lazy(() => import('@/pages/Contact'));
const Conseil = lazy(() => import('@/pages/Conseil'));
const Formations = lazy(() => import('@/pages/Formations'));
const FormationDetail = lazy(() => import('@/pages/FormationDetail'));
const CasClients = lazy(() => import('@/pages/CasClients'));
const CasClientDetail = lazy(() => import('@/pages/CasClientDetail'));
const Intra = lazy(() => import('@/pages/Intra'));
const Quote = lazy(() => import('@/pages/Quote'));
const FinancementOpco = lazy(() => import('@/pages/FinancementOpco'));
const PackAirtable = lazy(() => import('@/pages/PackAirtable'));
const CertificationsOutils = lazy(() => import('@/pages/CertificationsOutils')); // Certifications outils no-code

const PageLoader = () => (
  <div className="min-h-screen flex items-center justify-center">
    Chargement...
  </div>
);

export function PublicRoutes() {
  return (
    <>
      <Route 
        path="/" 
        element={
          <Suspense fallback={<PageLoader />}>
            <Index />
          </Suspense>
        } 
      />
      <Route 
        path="/about" 
        element={
          <Suspense fallback={<PageLoader />}>
            <About />
          </Suspense>
        } 
      />
      <Route 
        path="/contact" 
        element={
          <Suspense fallback={<PageLoader />}>
            <Contact />
          </Suspense>
        } 
      />
      <Route 
        path="/conseil" 
        element={
          <Suspense fallback={<PageLoader />}>
            <Conseil />
          </Suspense>
        } 
      />
      <Route 
        path="/formations" 
        element={
          <Suspense fallback={<PageLoader />}>
            <Formations />
          </Suspense>
        } 
      />
      <Route 
        path="/formation/:id" 
        element={
          <Suspense fallback={<PageLoader />}>
            <FormationDetail />
          </Suspense>
        } 
      />
      <Route 
        path="/formations/packs/:slug" 
        element={
          <Suspense fallback={<PageLoader />}>
            <PackAirtable />
          </Suspense>
        } 
      />
      <Route 
        path="/cas-clients" 
        element={
          <Suspense fallback={<PageLoader />}>
            <CasClients />
          </Suspense>
        } 
      />
      <Route 
        path="/cas-clients/:id" 
        element={
          <Suspense fallback={<PageLoader />}>
            <CasClientDetail />
          </Suspense>
        } 
      />
      <Route 
        path="/intra" 
        element={
          <Suspense fallback={<PageLoader />}>
            <Intra />
          </Suspense>
        } 
      />
      <Route 
        path="/devis/:id" 
        element={
          <Suspense fallback={<PageLoader />}>
            <Quote />
          </Suspense>
        } 
      />
      <Route 
        path="/financement-opco" 
        element={
          <Suspense fallback={<PageLoader />}>
            <FinancementOpco />
          </Suspense>
        } 
      />
      <Route 
        path="/certifications-outils" 
        element={
          <Suspense fallback={<PageLoader />}>
            <CertificationsOutils />
          </Suspense>
        } 
      />
    </>
  );
}
